<!-- Modal Backdrop -->
<div *ngIf="show" class="fixed inset-0 z-50 overflow-y-auto">
  <div class="flex min-h-screen items-center justify-center p-4">
    <!-- Backdrop -->
    <div class="fixed inset-0 bg-black/60 transition-opacity" (click)="close()"></div>

    <!-- Modal Content -->
    <div class="relative bg-gray-800 rounded-xl shadow-2xl w-full max-w-4xl max-h-[85vh] flex flex-col border border-gray-700">
      <!-- Header -->
      <div class="flex items-center justify-between p-6 border-b border-gray-700">
        <div>
          <h2 class="text-xl font-semibold text-white">Projecten Selecteren</h2>
          <p class="text-sm text-gray-400 mt-1">Selecteer projecten om weer te geven</p>
        </div>
        <button (click)="close()" class="text-gray-400 hover:text-white transition-colors">
          <svg class="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>

      <!-- Search Bar -->
      <div class="p-4 border-b border-gray-700">
        <div class="relative">
          <svg class="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
          </svg>
          <input
            type="text"
            [(ngModel)]="searchQuery"
            (ngModelChange)="onSearchChange()"
            placeholder="Zoek projecten..."
            class="w-full pl-10 pr-4 py-3 bg-gray-700 border border-gray-600 rounded-lg text-gray-200 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent">
        </div>
      </div>

      <!-- Projects Grid -->
      <div class="flex-1 overflow-y-auto p-4">
        <!-- Loading State -->
        <div *ngIf="loading" class="flex items-center justify-center py-12">
          <div class="text-gray-400">Projecten laden...</div>
        </div>

        <!-- Empty State -->
        <div *ngIf="!loading && filteredProjects.length === 0" class="text-center py-12">
          <svg class="mx-auto h-12 w-12 text-gray-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
          </svg>
          <p class="mt-2 text-gray-400">Geen projecten gevonden</p>
          <p class="text-sm text-gray-500">Probeer een andere zoekterm</p>
        </div>

        <!-- Projects List -->
        <div *ngIf="!loading && filteredProjects.length > 0" class="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div
            *ngFor="let project of filteredProjects"
            (click)="project.id && toggleProject(project.id)"
            class="relative flex items-start p-4 rounded-lg cursor-pointer transition-all duration-200"
            [ngClass]="project.id && isSelected(project.id) ? 'bg-indigo-600/20 border-2 border-indigo-500' : 'bg-gray-700/50 border-2 border-transparent hover:bg-gray-700'">
            
            <!-- Checkbox -->
            <div class="flex-shrink-0 mr-4">
              <div 
                class="w-6 h-6 rounded-md border-2 flex items-center justify-center transition-colors"
                [ngClass]="project.id && isSelected(project.id) ? 'bg-indigo-600 border-indigo-600' : 'border-gray-500'">
                <svg *ngIf="project.id && isSelected(project.id)" class="w-4 h-4 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="3" d="M5 13l4 4L19 7" />
                </svg>
              </div>
            </div>

            <!-- Project Image -->
            <div *ngIf="getProjectImage(project)" class="flex-shrink-0 w-20 h-20 mr-4 rounded-lg overflow-hidden bg-gray-600">
              <img [src]="getProjectImage(project)" [alt]="getProjectTitle(project)" class="w-full h-full object-cover">
            </div>
            <div *ngIf="!getProjectImage(project)" class="flex-shrink-0 w-20 h-20 mr-4 rounded-lg bg-gray-600 flex items-center justify-center">
              <svg class="w-8 h-8 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
              </svg>
            </div>

            <!-- Project Info -->
            <div class="flex-1 min-w-0">
              <h3 class="text-sm font-semibold text-white truncate">{{ getProjectTitle(project) }}</h3>
              <div *ngIf="project.categories && project.categories.length > 0" class="flex flex-wrap gap-1 mt-1">
                <span *ngFor="let cat of project.categories" class="px-1.5 py-0.5 bg-indigo-600/20 text-indigo-300 text-xs rounded">{{ cat }}</span>
              </div>
              <p class="text-xs text-gray-400 mt-1 line-clamp-2">{{ getProjectDescription(project) }}</p>
              <div *ngIf="project.tags && project.tags.length > 0" class="flex flex-wrap gap-1 mt-2">
                <span *ngFor="let tag of project.tags.slice(0, 3)" class="px-2 py-0.5 bg-gray-600 text-gray-300 text-xs rounded">
                  {{ tag }}
                </span>
                <span *ngIf="project.tags.length > 3" class="text-xs text-gray-500">
                  +{{ project.tags.length - 3 }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Footer -->
      <div class="flex items-center justify-between p-6 border-t border-gray-700 bg-gray-800/50">
        <div class="text-sm text-gray-400">
          {{ getSelectedCount() }} project{{ getSelectedCount() !== 1 ? 'en' : '' }} geselecteerd
        </div>
        <div class="flex gap-3">
          <button
            (click)="close()"
            class="px-4 py-2 text-gray-300 hover:text-white transition-colors">
            Annuleren
          </button>
          <button
            (click)="confirmSelection()"
            class="px-6 py-2 bg-indigo-600 text-white rounded-lg hover:bg-indigo-500 transition-colors font-medium">
            Selecteren
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
